import type { IBreadcrumbConfig } from '../types';

export const sysBreadcrumbConfig: IBreadcrumbConfig = {
  '/sys': 'Mission Control',
  '/sys/billing': 'Billing',
  '/sys/billing/users/[userId]': 'User Billing',
  '/sys/configs': 'Configs',
  '/sys/database': 'Database',
  '/sys/media': 'Media',
  '/sys/pipeline': 'Pipeline',
  '/sys/subtitles': 'Subtitles',
  '/sys/upload-queue': 'Upload Queue',
  '/sys/challenges': 'Challenges',
  '/sys/challenges/new': 'New Challenge',
  '/sys/challenges/populate': 'Populate',
  '/sys/challenges/audio-gen': 'Audio Gen',
  '/sys/challenges/[id]': 'Challenge',
  '/sys/challenges/[id]/edit': 'Edit',
  '/sys/challenges/[id]/clips/[clipId]': 'Clip',
  '/sys/challenges/[id]/clips/new': 'New Clip',
  '/sys/challenges/[id]/translations/[translationId]': 'Translation',
  '/sys/challenges/[id]/translations/[translationId]/edit': 'Edit Translation',
  '/sys/challenges/[id]/translations/new': 'New Translation',
  '/sys/collections': 'Collections',
  '/sys/collections/new': 'New Collection',
  '/sys/collections/table': 'Collections Table',
  '/sys/collections/[id]': 'Collection',
  '/sys/collections/[id]/edit': 'Edit',
  '/sys/collections/[id]/subtitle': 'Subtitle',
  '/sys/collections/[id]/triage': 'Triage',
  '/sys/collections/[id]/clips-list': 'Clips List',
  '/sys/ticket': 'Tickets',
  '/sys/ticket/[id]': 'Ticket',
  '/sys/users': 'Users',
  '/sys/users/new': 'New User',
  '/sys/users/[id]': 'Edit User',
  '/sys/users/[id]/progress': 'Progress',
};
